import React, { useEffect, useState } from 'react';
import axios from "axios";
import useDateFormatter from '../hooks/useDateFormatter';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { getEnvVar } from "../config/env-config";

function MaintenancePage() {
    const [tableData, setTableData] = useState({});
    const formatDate = useDateFormatter();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const redirect = searchParams.get("redirect");

    useEffect(() => {
        document.title = "Under Maintenance";
    }, []);

    useEffect(() => {
        axios
            .post((getEnvVar('REACT_APP_USER_PUBLIC_URL') || '') + "api/public/" + 'maintainence_status', {})
            .then((response) => {
                const outlook = response;
                if (outlook.data.code === 200) {
                    navigate(`${redirect}`);
                } else if (outlook.data.code === 503) {
                    const MaintenanceData = outlook.data.data || {};
                    setTableData(MaintenanceData);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    return (
        <div className="min-h-screen bg-gradient-to-br from-white via-gray-50 to-gray-100 flex items-center justify-center p-6">
            <div className="relative bg-white p-10 rounded-3xl shadow-xl border border-gray-200 max-w-xl w-full text-center text-gray-800">

                {/* Glowing Circle */}
                <div className="absolute -top-10 left-1/2 transform -translate-x-1/2">
                    <div className="bg-gradient-to-tr from-yellow-400 to-orange-500 rounded-full p-4 shadow-lg animate-pulse">
                        <svg
                            className="w-12 h-12 text-white animate-spin-slow"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M15.232 5.232l3.536 3.536m-2.036-6.036A9.003 9.003 0 0012 3c-4.97 0-9 4.03-9 9 0 1.316.284 2.568.792 3.708l1.744-1.744a7.002 7.002 0 1110.592 2.952l1.744 1.744A8.963 8.963 0 0021 12c0-2.485-1.007-4.735-2.636-6.364z"
                            />
                        </svg>
                    </div>
                </div>

                {/* Heading */}
                <h1 className="mt-6 text-4xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-orange-500 via-yellow-400 to-orange-400">
                    We'll Be Right Back!
                </h1>

                {/* Subtext */}
                <p className="mt-4 text-gray-600 text-md leading-relaxed">
                    Our platform is undergoing scheduled maintenance from:
                    <br />
                    <span className="text-orange-600 font-semibold">{formatDate(tableData?.scheduledAt)}</span> to <span className="text-orange-600 font-semibold">{formatDate(tableData?.expectedEnd)}</span>.
                </p>

                <p className="mt-4 text-gray-600 text-md leading-relaxed">
                    {tableData.message && (
                        <>
                            <span className="text-orange-600 font-semibold">{tableData?.message}</span>
                            <br />
                        </>
                    )}
                    We're working hard to improve your experience.
                </p>

                {/* Footer */}
                <div className="mt-8 border-t border-gray-300 pt-4">
                    <p className="text-sm text-gray-500 italic">— Thank you for your patience and understanding.</p>
                </div>
            </div>
        </div>
    );
}

export default MaintenancePage;
